import React, {Component} from 'react';
import {withRouter} from 'react-router-dom'
import {Redirect} from "react-router-dom";
import {BASE_URL} from "./configuration";

class Logout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect : false
        }
    }

    logout() {
        if (localStorage.getItem("userRole") === "ROLE_IMPERSONATE") {

            localStorage.setItem("tokenString", localStorage.getItem("oldTokenString"));
            localStorage.removeItem("newTokenString");
            localStorage.removeItem("oldTokenString");
            localStorage.setItem("userRole", "ROLE_ADMIN");
            window.location.replace(BASE_URL + 'admin/inquiries/viewAll');
        } else {
            localStorage.clear();

            window.location.replace(BASE_URL + 'quotation/pcb');
        }

    }

    componentDidMount() {
        this.logout();
    }

    render() {
        return (
            <div className="logout">
            </div>
        );
    }
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/Logout.js